/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SwatchSelector_transactions$ref = any;
export type PdpRespSwatchSelector_transactions$ref = any;
export type PdpRespSwatchSelector_transactions = {
    readonly " $fragmentRefs": SwatchSelector_transactions$ref;
    readonly " $refType": PdpRespSwatchSelector_transactions$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_transactions",
      "args": null
    }
  ]
};
(node as any).hash = 'bca00afd302d558a31c1e43074357b6b';
export default node;
